import { useSubscription } from '@apollo/client'
import { setAlertQueue } from 'cache/alerts'
import {
  ON_DECISION_EDIT_PAGE_UPDATED,
  OnDecisionEditPageUpdatedResponse,
  OnDecisionEditPageUpdatedVariables,
} from 'queries/subscriptions/on-decision-edit-page-updated'
import { MessageType } from 'ts/enums/messageType.enums'

interface UseDecisionEditPageUpdatedOptions {
  onDataUpdated: () => Promise<void>
}

export const useDecisionEditPageUpdated = (
  dealId: number | undefined,
  { onDataUpdated }: UseDecisionEditPageUpdatedOptions
) => {
  useSubscription<OnDecisionEditPageUpdatedResponse, OnDecisionEditPageUpdatedVariables>(
    ON_DECISION_EDIT_PAGE_UPDATED,
    {
      variables: { dealId: dealId ?? 0 },
      skip: !dealId,
      fetchPolicy: 'no-cache',
      onData: ({ data: { data } }) => {
        if (data?.onDecisionEditPageUpdated?.dataUpdated) {
          onDataUpdated()
            .then(() => {
              setAlertQueue({
                type: MessageType.SUCCESS,
                message: 'The product grid has been refreshed with the latest data.',
              })
            })
            .catch((error) => {
              console.error('Failed to refresh data after update:', error)
              setAlertQueue({
                type: MessageType.WARNING,
                message: 'Changes saved but failed to refresh. Please reload the page.',
              })
            })
        }
      },
      onError: (error) => {
        console.error('Decision edit page VA update subscription error:', error)
      },
    }
  )
}
